import { faArrowLeft, faMinusCircle, faPlusCircle, faUpload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Autocomplete, Box, Button, CircularProgress, Input, OutlinedInput, TextField } from '@mui/material'
import { MobileDatePicker } from '@mui/x-date-pickers'
import dayjs from 'dayjs'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import Page from '../../component/Page'
import { getCustomers, getItemMasterList, LocationList } from '../setting/services/settingApi'
import StockContext from './services/stockApi'
import { checkReserveCenter, GetBreedClassNo, GetSeasonNo, getStatusName, StockStatus } from './services/stockService'

import api from '../../api/api'
import { STOCK_CONFIG } from './config'
import './reserveDetail.scss'
import ConfirmDialogReserve from './component/confirmDialogReserve'
import ConfirmPrint from './component/confirmPrint'
import Swal from 'sweetalert2'
import useDebounce from '../../hook/useDebounce'

// import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
const BrowserInput = function BrowserInput(props) {
    const { inputProps, InputProps, ownerState, value, inputRef, error, ...other } = props;
    return (
        <TextField {...inputProps} ref={inputRef} value={value ? value.substring(0, value?.length - 6) + (parseInt(value?.substring(value?.length - 6)) + 543).toString() : null} {...other} variant="standard" fullWidth
            InputProps={{
                disableUnderline: true,
            }}
        />
    );
};
export default function AddReserve() {
    const navigate = useNavigate();

    const { id } = useParams()
    const fileRef = useRef()
    const { getReservesSeedDetail, getImportReserves } = useContext(StockContext);
    const { profile, loading } = useSelector(state => state.profile)
    const [detail, setDetail] = useState(null)
    const [name, setName] = useState()
    const [refNo, setRefNo] = useState('')
    const [campaignName, setCampaignName] = useState('')
    const [remark, setRemark] = useState('')
    const [documentDate, setDocumentDate] = useState(dayjs(new Date()))
    const [customers, setCustomers] = useState([])
    const [location, setLocation] = useState([])
    const [RLocation, setRLocation] = useState([])
    const [locations, setLocations] = useState([])
    const [valueC, setValueC] = useState();
    const [inputValueC, setInputValueC] = useState('');
    const [value, setValue] = useState(null);
    const [valueRP, setValueRP] = useState(null);
    const [P, setP] = useState('');
    const [D, setD] = useState('');
    const [SD, setSD] = useState('');
    const debouncedSearchPR = useDebounce(P, 500)
    const debouncedSearchDR = useDebounce(D, 500)
    const debouncedSearchSDR = useDebounce(SD, 500)
    const debouncedSearchC = useDebounce(inputValueC, 500)
    const [loadingsubmit, setLoadingsubmit] = useState(false);

    const [inputValueP, setInputValueP] = useState('');
    const [inputValueD, setInputValueD] = useState('');
    const debouncedSearchP = useDebounce(inputValueP, 500)
    const debouncedSearchD = useDebounce(inputValueD, 500)
    const [importExcel, setImportExcel] = useState(false);
    const [open, setOpen] = useState(false);
    const [openP, setOpenP] = useState(false);
    const [loadingPDF, setLoadingPDF] = useState(false);
    const [campaignError, setcampaignError] = useState(false);
    const [refNoError, setrefNoError] = useState(false);
    const [customersError, setcustomersError] = useState(false);
    const [rows, setRows] = useState([
        {
            District: "",
            DueDate: "",
            Freight: 0,
            ItemNo: null,
            Province: "",
            Qty: 0,
            SubDistrict: "",
            UnitNo: null,
            Year: "",
        },
        {
            District: "",
            DueDate: "",
            Freight: 0,
            ItemNo: null,
            Province: "",
            Qty: 0,
            SubDistrict: "",
            UnitNo: null,
            Year: "",
        },
        {
            District: "",
            DueDate: "",
            Freight: 0,
            ItemNo: null,
            Province: "",
            Qty: 0,
            SubDistrict: "",
            UnitNo: null,
            Year: "",
        },
        {
            District: "",
            DueDate: "",
            Freight: 0,
            ItemNo: null,
            Province: "",
            Qty: 0,
            SubDistrict: "",
            UnitNo: null,
            Year: "",
        },
        {
            District: "",
            DueDate: "",
            Freight: 0,
            ItemNo: null,
            Province: "",
            Qty: 0,
            SubDistrict: "",
            UnitNo: null,
            Year: "",
        },
    ]);
    function addRow() {
        const newRow = {
            District: "",
            DueDate: "",
            Freight: 0,
            ItemNo: null,
            Province: "",
            Qty: 0,
            SubDistrict: "",
            UnitNo: null,
            Year: "",
        }

        setRows([...rows, newRow]);
    }
    const deletehand = (i) => {
        const data = rows?.filter((e, index) => i !== index);
        setRows(data);
    };
    const [items, setItems] = useState([]);
    function checkReserveCenter() {
        const ReserveNoCenter = detail ? detail?.ReserveNo.split('-') : [];
        return ReserveNoCenter.length > 1 ? true : false
    }
    useEffect(() => {
        if (id) {
            getReservesSeedDetail(id, setDetail)
        }
        const body = {
            typeSearch: '',
            Text: ''
        };
        LocationList(body, setLocation)
        LocationList(body, setRLocation)


    }, [])
    useEffect(() => {
        if (debouncedSearchC.length > 3) {
            getCustomers(debouncedSearchC, null, setCustomers)
        }
    }, [debouncedSearchC])
    useEffect(() => {
        if (debouncedSearchP.length >= 0) {
            const body = {
                typeSearch: 'P',
                Text: debouncedSearchP
            };
            LocationList(body, setLocation)
        }
        if (debouncedSearchD.length >= 0) {
            const body = {
                typeSearch: 'D',
                Text: debouncedSearchD
            };
            LocationList(body, setLocation)
        }
    }, [debouncedSearchP, debouncedSearchD])
    useEffect(() => {
        if (debouncedSearchPR.length >= 0) {
            const body = {
                typeSearch: 'P',
                Text: debouncedSearchPR
            };
            LocationList(body, setRLocation)
        }
        if (debouncedSearchDR.length >= 0) {
            const body = {
                typeSearch: 'D',
                Text: debouncedSearchDR
            };
            LocationList(body, setRLocation)
        }
        if (debouncedSearchSDR.length >= 0) {
            const body = {
                typeSearch: 'SD',
                Text: debouncedSearchSDR
            };
            LocationList(body, setRLocation)
        }

    }, [debouncedSearchPR, debouncedSearchDR, debouncedSearchSDR])

    useEffect(() => {
        const uniqueDistrictId = [];
        setLocations(location.slice().filter(element => {
            const isDuplicate = uniqueDistrictId.includes(element.DistrictId);

            if (!isDuplicate) {
                uniqueDistrictId.push(element.DistrictId);

                return true;
            }

            return false;
        }))
    }, [location])
    useEffect(() => {
        getItemMasterList(name, setItems)
    }, [name])
    useEffect(() => {

        if (detail) {
            const Ref = checkReserveCenter() ? detail?.RefNo.slice(7) : detail?.RefNo.slice(6)
            setRefNo(Ref)
            setCampaignName(detail?.CampaignName)
            setRemark(detail?.Remark)
            setDocumentDate(dayjs(detail?.DocumentDate))
            setValue({ ProvinceName: detail?.Province, DistrictName: detail?.District })
            setValueC(detail?.CustomerNo)
            setRows(detail?.ReserveDetails)
        }
    }, [detail])
    async function importReserves(_file) {

        const frmData = new FormData();
        frmData.append('file', _file);
        const res = await getImportReserves(frmData);
        if (res.length > 0) {
            Swal.fire({
                title: 'ทำรายการสำเร็จ',
                icon: 'success',
            })
            const creds = [];

            for (const c of res) {
                const _qty = (c?.Qty || 0);
                const totalPrice = (c?.ItemNo?.SalePrice) * (_qty);
                const _freight = !c?.Freight ? _qty : c?.Freight;
                creds.push({
                    ReserveDetailId: null,
                    ReserveHeadId: null,
                    ItemName: c?.ItemNo?.ItemName,
                    ItemNo: c?.ItemNo,
                    CatalogName: c?.ItemNo?.CatalogNo?.CatalogName,
                    Chemical: c?.ItemNo?.Chemical,
                    Season: c?.ItemNo?.Season,
                    Option1: c?.ItemNo?.Option1,
                    Option2: c?.ItemNo?.Option2,
                    Year: c?.Year,
                    Province: c?.Province,
                    District: c?.District,
                    BranchName: c?.BranchNo?.BranchName,
                    SubDistrict: c?.SubDistrict,
                    Freight: _freight,
                    UnitNo: c?.ItemNo?.UnitNo?.UnitNo,
                    UnitName: 'กิโลกรัม',
                    Qty: _qty.toLocaleString() || 0,
                    BranchNo: c?.BranchNo?.BranchNo,
                    SalePrice: c?.ItemNo?.SalePrice,
                    SoldByDoiNo: [],
                    TotalPrice: totalPrice.toLocaleString() || 0,
                    DueDate: c?.DueDate
                });
                setRows(creds)

                // this.initSearch(creds.length - 1);
                // this.initCalculate(creds.length - 1);
            }
        }

    }


    async function uploadFile(event) {

        setImportExcel(true)
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            const fileUpload = file;
            if (fileUpload?.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                setImportExcel(false)
                return alert('กรุณาอัพโหลดไฟล์ excel');
            }

            await importReserves(fileUpload);
        }
        event.target.value = '';
        setImportExcel(false)
    }

    const reserveAdd = async (body) => {
        setLoadingsubmit(true)
        if (body?.ReserveNo) {
            const url = STOCK_CONFIG.requests.getReserves.url + `/${body?.ReserveNo}`;
            const res = await api.put(url, body)
            const data = res.data
            if (data.status === true) {
                if (body.Status === 'N') {
                    Swal.fire(
                        'ยกเลิกรายการสำเร็จ',
                        '',
                        'success'
                    )
                    getReservesSeedDetail(id, setDetail)
                    navigate('/stock/reserve/' + data.result.ReserveNo)
                    setOpen(false)
                    setLoadingsubmit(false)
                } else {
                    getReservesSeedDetail(id, setDetail)
                    navigate('/stock/reserve/' + data.result.ReserveNo)
                    setOpenP(true)
                    setOpen(false)
                    setLoadingsubmit(false)
                }

            } else {
                Swal.fire({
                    title: data?.message || 'ทำรายการไม่สำเร็จ',
                    icon: 'warning',
                })
                setLoadingsubmit(false)
            }


        } else {
            const res = await api.post(STOCK_CONFIG.requests.getReserves.url, body)
            const data = res.data
            if (data.status === true) {
                navigate('/stock/reserve/' + data.result.ReserveNo)
                setOpenP(true)
                setOpen(false)
                setLoadingsubmit(false)

            } else {
                Swal.fire({
                    title: data?.message || 'ทำรายการไม่สำเร็จ',
                    icon: 'warning',
                })
                setLoadingsubmit(false)
            }


        }

    }
    const handleSubmit = (e) => {
        const body = {
            ReserveNo: id || null,
            CampaignName: campaignName,
            RefNo: checkReserveCenter() ? 'กษ2604/' : 'กษ2604' + refNo,
            DocumentDate: dayjs(documentDate).format('YYYY-MM-DD'),
            CustomerNo: valueC?.CustomerNo,
            Remark: remark,
            Province: value?.ProvinceName,
            District: value?.DistrictName,
            Status: e,

            ReserveDetails: rows?.filter((y) => y.ItemNo)?.map((x) => (
                {
                    ...x,
                    ReserveDetailCode: x?.ReserveDetailCode || null,
                    BranchNo: x?.BranchNo || profile?.BranchNo?.BranchNo,
                    ItemNo: x?.ItemNo?.ItemNo,
                    Year: x?.Year,
                    Province: x?.Province,
                    District: x?.District,
                    SubDistrict: x?.SubDistrict,
                    Qty: +x?.Qty.toString().replaceAll(',', ''),
                    Freight: x?.Freight,
                    UnitNo: x?.UnitNo?.UnitNo || x?.ItemNo?.UnitNo?.UnitNo,
                    DueDate: x?.DueDate
                }
            ))
        }

        reserveAdd(body)
    }

    function CheckSoldDetail() {
        const soldList = rows?.filter(x => x?.SoldByDoiNo?.length > 0);
        return soldList?.length > 0 ? false : true;
    }


    async function Close() {

        Swal.fire({
            title: `ยืนยันการปิดใบสำรอง: ${detail?.RefNo}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#4ab866',
            cancelButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                const body = {
                    ReserveNo: detail?.ReserveNo,
                    Status: 'C'
                }
                reserveAdd(body)
            }
        })

    }
    async function downloadReserve() {
        setLoadingPDF(true)
        const res = await api.get(STOCK_CONFIG.requests.getReserves.url + `/${id}/pdf`, {
            responseType: 'arraybuffer'
        })
        const buffer = res.data
        const blob = new Blob([buffer], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        setLoadingPDF(false)
    }


    return (
        <div style={{ padding: '10px 30px' }}>
            <Page>
                <form>
                    <div class="container-fluid">
                        <div class="d-flex row align-items-center ">
                            <div class="col-6">
                                <label class="title-content mb-4">
                                    ข้อมูลสำรองโครงการ (ศูนย์)
                                </label>
                            </div>
                            {id &&
                                <div class="col-6 text-end px-4">
                                    <Button variant='contained' className="ButtomSearch" sx={{
                                        width: '110px',
                                        background: '#3364af57 0 0 no-repeat padding-box',
                                        border: '1px solid #3364af57',
                                        color: '#3364af',
                                        fontWeight: '700',
                                        borderRadius: '100px', ':hover': {
                                            background: '#3364af57 0 0 no-repeat padding-box',
                                        }
                                    }} onClick={downloadReserve}>{loadingPDF ? <CircularProgress size={'18px'} color="inherit" /> : 'พิมพ์'}</Button>
                                </div>
                            }

                        </div>

                        <div class="row">
                            <div class="col-lg-4 col-md-12">
                                <label class="labelInput">เลขที่หนังสือสำรองเมล็ดพันธุ์ข้าว</label>
                                <Box className={`backgroundField ${refNoError ? 'error' : ''}`}>
                                    <span>
                                        <div class="prefix-doc ">
                                            {checkReserveCenter(detail) ? 'กษ2604/' : 'กษ2604'}
                                        </div>
                                    </span>
                                    <TextField value={refNo} onChange={e => setRefNo(e.target.value)} variant="standard" fullWidth onBlur={e => {
                                        if (!e.target.value) {
                                            setrefNoError(true)
                                        } else {
                                            setrefNoError(false)
                                        }
                                    }}
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                    />
                                </Box>
                                {refNoError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณากรอกเลขที่หนังสือ
                                </span>}
                            </div>
                            <div class="col-lg-4 col-md-12">
                                <label class="labelInput">สถานะเอกสาร</label>
                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField value={getStatusName(detail?.Status)} variant="standard" fullWidth disabled
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                    />
                                </Box>
                            </div>



                        </div>
                        <div class="row">
                            <div class="col-lg-8 col-md-12">
                                <label class="labelInput">ชื่อโครงการ</label>
                                <Box className={`backgroundField ${campaignError ? 'error' : ''}`}>

                                    <TextField value={campaignName} onChange={e => setCampaignName(e.target.value)} variant="standard" fullWidth onBlur={e => {
                                        if (!e.target.value) {
                                            setcampaignError(true)
                                        } else {
                                            setcampaignError(false)
                                        }
                                    }}
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                    />
                                </Box>
                                {campaignError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณากรอกชื่อโครงการ</span>}

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4 col-md-12">
                                <label class="labelInput">สำรองให้</label>

                                <Autocomplete
                                    fullWidth

                                    onBlur={e => {
                                        if (!valueC) {
                                            setcustomersError(true)
                                        } else {
                                            setcustomersError(false)
                                        }
                                    }}
                                    options={customers || []}
                                    // getOptionLabel={(option) => option?.ContactName}
                                    getOptionLabel={(option) => `( ${option?.CustomerNo} ) ${option?.ContactName}`}
                                    renderOption={(props, option) => (
                                        <Box component="li" {...props} key={option.CustomerId}>
                                            ( {option?.CustomerNo} ) {option?.ContactName}
                                        </Box>
                                    )}
                                    loading={customers.length > 0}
                                    inputValue={inputValueC || ''}
                                    onInputChange={(event, newInputValue) => {
                                        setInputValueC(newInputValue);
                                    }}
                                    value={valueC || null}
                                    onChange={(event, newValue) => {
                                        setValueC(newValue)
                                    }}

                                    renderInput={(params) => (
                                        <Box className={`backgroundField ${customersError ? 'error' : ''}`} ref={params.InputProps.ref}>
                                            <Input type="text" {...params.inputProps} disableUnderline />

                                        </Box>
                                    )}
                                />
                                {customersError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณาเลือกลูกค้า</span>}

                            </div>
                            <div class="col-lg-4 col-md-12">
                                <label class="labelInput">วันที่เอกสาร</label>
                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <MobileDatePicker
                                        dayOfWeekFormatter={(day) => `${day}`}
                                        value={documentDate} onChange={e => setDocumentDate(e)}
                                        slotProps={{ textField: { variant: 'standard', fullWidth: true, InputProps: { disableUnderline: true }, value: documentDate } }}
                                        slots={{
                                            textField: BrowserInput,
                                        }}
                                    />
                                </Box>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-lg-4 col-md-12">
                                <label class="labelInput">จังหวัด</label>

                                <Autocomplete
                                    fullWidth

                                    options={locations || []}
                                    getOptionLabel={(option) => option?.ProvinceName}
                                    // options={locations.map((option) => option?.ProvinceName)}
                                    renderOption={(props, option) => (
                                        <Box component="li" {...props} key={option.ProvinceId}>
                                            จ.{option?.ProvinceName} / อ.{option?.DistrictName}
                                        </Box>
                                    )}
                                    loading={locations.length > 0}
                                    inputValue={inputValueP || ''}
                                    onInputChange={(event, newInputValue) => {
                                        setInputValueP(newInputValue);
                                    }}
                                    value={value || null}
                                    onChange={(event, newValue) => {
                                        setValue(newValue)

                                    }}

                                    renderInput={(params) => (
                                        <Box className='backgroundField' sx={{ marginBottom: '10px' }} ref={params.InputProps.ref}>
                                            <Input type="text" {...params.inputProps} disableUnderline />

                                        </Box>
                                    )}
                                />
                            </div>
                            <div class="col-lg-4 col-md-12">
                                <label class="labelInput">อำเภอ</label>
                                <Autocomplete
                                    fullWidth

                                    options={locations || []}
                                    getOptionLabel={(option) => option?.DistrictName}
                                    renderOption={(props, option) => (
                                        <Box component="li" {...props} key={option.DistrictId}>
                                            จ.{option?.ProvinceName} / อ.{option?.DistrictName}
                                        </Box>
                                    )}
                                    loading={locations.length > 0}
                                    inputValue={inputValueD || ''}
                                    onInputChange={(event, newInputValue) => {
                                        setInputValueD(newInputValue);
                                    }}
                                    value={value || null}
                                    onChange={(event, newValue) => {
                                        setValue(newValue)
                                        // setValueD(newValue)
                                    }}

                                    renderInput={(params) => (
                                        <Box className='backgroundField' sx={{ marginBottom: '10px' }} ref={params.InputProps.ref}>
                                            <Input type="text" {...params.inputProps} disableUnderline />

                                        </Box>
                                    )}
                                />
                            </div>

                        </div>
                        {id && <div class="row">
                            <div class="col-lg-4 col-md-6">
                                <label class="labelInput me-3">ผู้สร้าง</label> <label class="message-error-label">( {dayjs(detail?.CreateDate).format('DD/MM/BBBB')} )</label>
                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField value={detail?.CreateId} variant="standard" fullWidth disabled={id ? true : false}
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                    />
                                </Box>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <label class="labelInput me-3">ผู้แก้ไข</label> <label class="message-error-label">( {dayjs(detail?.ModifiedDate).format('DD/MM/BBBB')} )</label>
                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField value={detail?.ModifiedId} variant="standard" fullWidth disabled={id ? true : false}
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                    />
                                </Box>
                            </div>
                        </div>}

                        <div class="row">
                            <div class="col-lg-8 col-md-12">
                                <label class="labelInput">หมายเหตุ</label>
                                <Box className='backgroundField' sx={{ marginBottom: '10px', borderRadius: '25px' }}>
                                    <TextField value={remark} onChange={e => setRemark(e.target.value)} variant="standard" fullWidth multiline rows={3}
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                    />
                                </Box>
                            </div>

                        </div>


                        <div class="d-flex row align-items-center mt-5 mb-4">
                            <div class="col-md-4 col-sm-12">
                                <label class="title-content">
                                    รายการสำรองเมล็ดพันธ์ุ
                                </label>
                            </div>
                            {id ? null :
                                <div class="col-md-8 col-sm-12 text-end" style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                                    <input
                                        type="file" ref={fileRef} accept=".xlsx,.csv,.xls" hidden onChange={uploadFile} />
                                    <Button variant='outlined' onClick={() => fileRef.current.click()}
                                        startIcon={<FontAwesomeIcon icon={faUpload} />}
                                        sx={{ width: '180px', fontSize: '14px', marginRight: '10px' }}>อัพโหลด Excel</Button>
                                    <FontAwesomeIcon icon={faPlusCircle} onClick={addRow} />
                                </div>}
                        </div>
                        <div class="reserveDetail row">
                            <div class="col-md-12 table-responsive-sm " style={{ height: 'auto' }}>
                                <table class="table table-borderless  ">
                                    <thead>
                                        <tr>
                                            <th scope="col ">ที่</th>
                                            <th scope="col ">เมล็ดพันธุ์</th>
                                            <th scope="col ">ชั้นพันธุ์</th>
                                            <th scope="col ">ฤดู</th>
                                            <th scope="col ">ปี</th>
                                            <th scope="col ">ชนิดข้าว</th>
                                            <th scope="col ">สารเคมี</th>
                                            <th scope="col ">จังหวัด</th>
                                            <th scope="col ">อำเภอ</th>
                                            <th scope="col ">ตำบล</th>
                                            <th scope="col ">จำนวน</th>
                                            <th scope="col ">หน่วย</th>
                                            <th scope="col ">ราคา/หน่วย</th>
                                            <th scope="col ">ราคารวม</th>
                                            <th scope="col ">ค่าขนส่ง</th>
                                            {/* <th scope="col " style={{ width: '10%' }}>ศูนย์</th> */}
                                            <th scope="col " style={{ width: '10%' }}>วันที่รับ</th>
                                            <th scope="col "></th>
                                        </tr>
                                    </thead>
                                    <tbody class="">
                                        {rows?.map((x, i) => (
                                            <tr>
                                                <td>{i + 1}.</td>
                                                <td class="text-center">
                                                    <Autocomplete

                                                        size='small'
                                                        readOnly={x?.SoldByDoiNo?.length > 0 ? true : false}
                                                        options={items}
                                                        getOptionLabel={(option) => option?.ItemName}
                                                        componentsProps={{
                                                            paper: {
                                                                sx: {
                                                                    width: 500
                                                                }
                                                            }
                                                        }}
                                                        renderOption={(props, option) => (
                                                            <Box component="li" {...props} key={option.ItemNo}>
                                                                {option?.CatalogNo?.CatalogName} {option?.Option2} <span style={{ color: option?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold', margin: '0 10px' }}>{option?.Season}</span> {option?.Option1} {option?.Chemical}
                                                            </Box>
                                                        )}
                                                        value={x?.ItemNo}
                                                        onChange={(event, newValue) => {
                                                            // const branchNo = profile?.BranchNo?.BranchNo
                                                            // const breedClassNo = GetBreedClassNo(x?.Option2)
                                                            // const seasonNo = GetSeasonNo(x?.Season)
                                                            // const lotNumber = branchNo + breedClassNo + seasonNo + x?.Year;
                                                            const item = rows?.map((v, index) => {

                                                                // v.LotGen = index === i ? lotNumber : v?.LotGen;
                                                                v.ItemNo = index === i ? newValue : v?.ItemNo;
                                                                return v;

                                                            });
                                                            setRows([...item]);

                                                        }}

                                                        renderInput={(params) => (
                                                            <Box ref={params.InputProps.ref}>
                                                                <OutlinedInput {...params.inputProps} fullWidth size='small' sx={{ width: '180px', padding: '0 !important', background: x?.SoldByDoiNo?.length > 0 ? '#e9ecef' : '#fff' }} />
                                                            </Box>)}
                                                    />
                                                </td>

                                                <td class="text-center">{x?.ItemNo?.Option2}</td>

                                                <td class="text-center"> <span style={{ color: x?.ItemNo?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold', margin: '0 10px' }}>{x?.ItemNo?.Season}</span></td>
                                                <td class="text-center">
                                                    <TextField value={x?.Year} className='w-60'

                                                        size='small' sx={{ background: id ? '#e9ecef' : '#fff' }} variant='outlined' onChange={e => {

                                                            const item = rows?.map((v, index) => {
                                                                v.Year = index === i ? e.target.value : v?.Year;
                                                                return v;

                                                            });
                                                            setRows([...item]);
                                                        }}
                                                        InputProps={{
                                                            readOnly: x?.SoldByDoiNo?.length > 0 ? true : false
                                                        }}
                                                        onKeyPress={(event) => {
                                                            if (!/[0-9]/.test(event.key)) {
                                                                event.preventDefault();
                                                            }
                                                        }} />
                                                </td>
                                                <td class="text-center">{x?.ItemNo?.Option1}</td>
                                                <td class="text-center">{x?.ItemNo?.Chemical}</td>
                                                <td class="text-center">
                                                    <Autocomplete
                                                        fullWidth
                                                        readOnly={x?.SoldByDoiNo?.length > 0 ? true : false}
                                                        options={RLocation || []}
                                                        // getOptionLabel={(option) => option?.ContactName}
                                                        getOptionLabel={(option) => option?.Province || option?.ProvinceName || ''}
                                                        componentsProps={{
                                                            paper: {
                                                                sx: {
                                                                    width: 500
                                                                }
                                                            }
                                                        }}
                                                        loading={RLocation.length > 0}
                                                        renderOption={(props, option) => (
                                                            <Box component="li" {...props} key={option.ProvinceName}>
                                                                จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต. {option?.SubDistrictName}
                                                            </Box>
                                                        )}
                                                        inputValue={x?.NProvince || ''}
                                                        onInputChange={(event, newInputValue) => {
                                                            setP(newInputValue);
                                                            const item = rows?.map((v, index) => {
                                                                v.NProvince = index === i ? newInputValue || '' : v?.NProvince;

                                                                return v;

                                                            });
                                                            setRows([...item]);
                                                        }}
                                                        value={x || null}
                                                        onChange={(event, newValue) => {
                                                            // setValueRP(newValue)
                                                            const item = rows?.map((v, index) => {
                                                                v.Province = index === i ? newValue?.ProvinceName || '' : v?.Province;
                                                                v.District = index === i ? newValue?.DistrictName || '' : v?.District;
                                                                v.SubDistrict = index === i ? newValue?.SubDistrictName || '' : v?.SubDistrict;
                                                                return v;

                                                            });
                                                            setRows([...item]);
                                                        }}

                                                        renderInput={(params) => (
                                                            <Box ref={params.InputProps.ref} >
                                                                <OutlinedInput {...params.inputProps} fullWidth size='small' sx={{ width: '120px', padding: '0 !important', background: x?.SoldByDoiNo?.length > 0 ? '#e9ecef' : '#fff' }} />
                                                            </Box>
                                                        )}
                                                    />
                                                </td>
                                                <td class="text-center">
                                                    <Autocomplete
                                                        readOnly={x?.SoldByDoiNo?.length > 0 ? true : false}
                                                        fullWidth
                                                        options={RLocation || []}
                                                        // getOptionLabel={(option) => option?.ContactName}
                                                        getOptionLabel={(option) => option?.District || option?.DistrictName || ''}
                                                        componentsProps={{
                                                            paper: {
                                                                sx: {
                                                                    width: 500
                                                                }
                                                            }
                                                        }}
                                                        loading={RLocation.length > 0}
                                                        renderOption={(props, option) => (
                                                            <Box component="li" {...props} key={option.DistrictName}>
                                                                จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต. {option?.SubDistrictName}
                                                            </Box>
                                                        )}
                                                        inputValue={x?.NDistrict || ''}
                                                        onInputChange={(event, newInputValue) => {
                                                            setD(newInputValue);
                                                            const item = rows?.map((v, index) => {
                                                                v.NDistrict = index === i ? newInputValue || '' : v?.NDistrict;

                                                                return v;

                                                            });
                                                            setRows([...item]);
                                                        }}
                                                        value={x || null}
                                                        onChange={(event, newValue) => {
                                                            const item = rows?.map((v, index) => {
                                                                v.Province = index === i ? newValue?.ProvinceName : v?.Province;
                                                                v.District = index === i ? newValue?.DistrictName : v?.District;
                                                                v.SubDistrict = index === i ? newValue?.SubDistrictName : v?.SubDistrict;
                                                                return v;

                                                            });
                                                            setRows([...item]);
                                                            // setValueRP(newValue)
                                                        }}

                                                        renderInput={(params) => (
                                                            <Box ref={params.InputProps.ref}>
                                                                <OutlinedInput {...params.inputProps} fullWidth size='small' sx={{ width: '120px', padding: '0 !important', background: id ? '#e9ecef' : '#fff' }} />
                                                            </Box>
                                                        )}
                                                    />
                                                </td>
                                                <td class="text-center">
                                                    <Autocomplete
                                                        fullWidth
                                                        readOnly={x?.SoldByDoiNo?.length > 0 ? true : false}
                                                        options={RLocation || []}
                                                        // getOptionLabel={(option) => option?.ContactName}
                                                        getOptionLabel={(option) => option?.SubDistrict || option?.SubDistrictName || ''}
                                                        componentsProps={{
                                                            paper: {
                                                                sx: {
                                                                    width: 500
                                                                }
                                                            }
                                                        }}
                                                        loading={RLocation.length > 0}
                                                        renderOption={(props, option) => (
                                                            <Box component="li" {...props} key={option.SubDistrictName}>
                                                                จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต. {option?.SubDistrictName}
                                                            </Box>
                                                        )}
                                                        inputValue={x?.NSubDistrict || ''}
                                                        onInputChange={(event, newInputValue) => {
                                                            setSD(newInputValue);
                                                            const item = rows?.map((v, index) => {
                                                                v.NSubDistrict = index === i ? newInputValue || '' : v?.NSubDistrict
                                                                return v;

                                                            });
                                                            setRows([...item]);
                                                        }}
                                                        value={x || null}
                                                        onChange={(event, newValue) => {
                                                            // setValueRP(newValue)
                                                            const item = rows?.map((v, index) => {
                                                                v.Province = index === i ? newValue?.ProvinceName || '' : v?.Province;
                                                                v.District = index === i ? newValue?.DistrictName || '' : v?.District;
                                                                v.SubDistrict = index === i ? newValue?.SubDistrictName || '' : v?.SubDistrict;
                                                                return v;

                                                            });
                                                            setRows([...item]);
                                                        }}

                                                        renderInput={(params) => (
                                                            <Box ref={params.InputProps.ref}>
                                                                <OutlinedInput {...params.inputProps} fullWidth size='small' sx={{ width: '120px', padding: '0 !important', background: id ? '#e9ecef' : '#fff' }} />
                                                            </Box>
                                                        )}
                                                    />
                                                </td>
                                                <td class="text-center">
                                                    <TextField value={x?.Qty.toLocaleString()} size='small' fullWidth variant='outlined' sx={{ background: x?.SoldByDoiNo?.length > 0 ? '#e9ecef' : '#fff', width: '100px' }} onChange={e => {
                                                        let newValue = e.target.value.replace(/,/g, "");

                                                        let abc = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                                        const item = rows?.map((v, index) => {
                                                            v.Qty = index === i ? abc : v?.Qty;
                                                            v.Freight = index === i ? abc.toString().replaceAll(',', '') : v?.Freight

                                                            return v;

                                                        });
                                                        setRows([...item]);
                                                    }} />
                                                </td>

                                                <td class="text-center">
                                                    {x?.ItemNo?.UnitNo?.UnitName || x?.UnitNo?.UnitName}
                                                </td>
                                                <td class="text-center">
                                                    {x?.ItemNo?.SalePrice}
                                                </td>
                                                <td class="text-center">
                                                    <TextField readOnly sx={{ background: x?.SoldByDoiNo?.length > 0 ? '#e9ecef' : '#fff', width: '120px' }} value={((x?.ItemNo?.SalePrice || 0) * +(x?.Qty.toString().replaceAll(',', ''))).toLocaleString()} size='small' fullWidth variant='outlined' onChange={e => {
                                                        // const item = rows?.map((v) => {
                                                        //     v.Lot = v?.id === x?.id ? e.target.value : v?.Lot;
                                                        //     return v;

                                                        // });
                                                        // setRows([...item]);
                                                    }} />
                                                </td>
                                                <td class="text-center">{x?.Freight.toLocaleString()}</td>
                                                <td class="text-center">
                                                    <TextField value={x?.DueDate} size='small' fullWidth variant='outlined' sx={{ background: x?.SoldByDoiNo?.length > 0 ? '#e9ecef' : '#fff', width: '120px' }} onChange={e => {
                                                        const item = rows?.map((v, index) => {
                                                            v.DueDate = i === index ? e.target.value : v?.DueDate;
                                                            return v;

                                                        });
                                                        setRows([...item]);
                                                    }} />
                                                </td>

                                                {/* <td> </td> */}
                                                <td>
                                                    {id ? null : <FontAwesomeIcon icon={faMinusCircle} onClick={() => deletehand(i)} />}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div class="row mt-3">

                                <div class="col-12 p-0 d-flex align-items-center justify-content-end">
                                    <div>
                                        <span class="total-text">รวม</span>
                                        <span class="total-price">{(rows?.map(x => +(x.Qty).toString().replaceAll(',', '')).reduce((p, n) => p + n, 0) || 0).toLocaleString()}</span>
                                        <span class="unit-price2">กิโลกรัม</span>
                                    </div>

                                    <div>
                                        <span class="approximate-text">ราคาประมาณการ</span>
                                        <span class="total-price">{parseFloat(rows?.map(x => ((+x?.ItemNo?.SalePrice || 0) * +(x?.Qty.toString().replaceAll(',', '')))).reduce((p, n) => p + n, 0) || 0).toFixed(2)
                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</span>
                                        <span class="unit-price2">บาท</span>
                                    </div>

                                    <div>
                                        <span class="approximate-text">ค่าขนส่งรวม</span>
                                        <span class="approximate-price">{parseFloat(rows?.map(x => +x.Freight).reduce((p, n) => p + n, 0) || 0).toFixed(2)
                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</span>
                                        <span class="unit-price">บาท</span>
                                    </div>
                                </div>

                            </div>
                            <div class="row mt-3">

                                <div class="col-12 p-0 d-flex align-items-center justify-content-end">
                                    <div>
                                        <span class="total-text">รวมทั้งสิ้น</span>
                                        <span class="total-price">{parseFloat(rows?.map(x => (+x?.ItemNo?.SalePrice || 0) * +(x?.Qty).toString().replaceAll(',', '')).reduce((p, n) => +p + +n, 0) + rows?.map(x => x.Freight).reduce((p, n) => +p + +n, 0) || 0).toFixed(2)
                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</span>
                                        <span class="unit-price">บาท</span>
                                    </div>


                                </div>

                            </div>

                        </div>
                        <hr class="chr" />
                        <div class="row mt-4">

                            <div class="col-12">
                                <div class="col-12">
                                    <Button onClick={() => navigate(-1)} variant='outlined'
                                        startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                                        sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
                                    {((profile?.BranchNo?.BranchNo === detail?.BranchNo?.BranchNo && !checkReserveCenter()) || (profile?.BranchNo?.BranchNo === '00' && checkReserveCenter()) || !detail) && <>
                                        {(detail?.Status !== StockStatus.Inactive && detail?.Status !== StockStatus.Close && detail?.Status !== StockStatus.Draft) && <Button variant='contained' sx={{ width: '130px', fontSize: '14px' }} onClick={() => {
                                            if (refNo.length === 0) {
                                                setrefNoError(true)
                                            }
                                            if (campaignName.length === 0) {
                                                setcampaignError(true)
                                            }
                                            if (inputValueC.length === 0) {
                                                setcustomersError(true)
                                            }
                                            if (refNo.length > 0 && campaignName.length > 0 && inputValueC.length > 0) {
                                                setOpen(true)
                                            }
                                        }}>{id ? 'แก้ไข' : 'บันทึก'}</Button>}
                                        {detail && (detail?.Status === StockStatus.Active && CheckSoldDetail()) && <Button variant='contained' color='error' sx={{ width: '130px', fontSize: '14px', marginLeft: '10px' }} onClick={() => {

                                            Swal.fire({
                                                title: `ยืนยันการยกเลิก`,
                                                icon: 'warning',
                                                showCancelButton: true,
                                                confirmButtonColor: '#4ab866',
                                                cancelButtonColor: '#d33',
                                            }).then((result) => {
                                                if (result.isConfirmed) {

                                                    handleSubmit(StockStatus.Inactive)
                                                }
                                            })

                                        }}>ยกเลิก</Button>}
                                        {detail && (detail?.Status === StockStatus.Active) && <Button variant='contained' sx={{
                                            width: '130px', fontSize: '14px', marginLeft: '10px', background: "#6c757d", ':hover': {
                                                background: '#6c757d'
                                            }
                                        }} onClick={Close}>ปิด</Button>}
                                    </>}
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

            </Page>
            <ConfirmPrint title={'บันทึกรายการสำรองเมล็ดพันธุ์สำเร็จ'} download={downloadReserve} open={openP} setOpen={setOpenP} loadingPDF={loadingPDF} linkTo='/stock/reserve/add' />
            <ConfirmDialogReserve open={open} setOpen={setOpen} rows={rows} handleAdd={handleSubmit} reserveType='notCenter' loadingsubmit={loadingsubmit} />
        </div>
    )
}
